


jointjsHacksRun.$inject = ['JointjsOptimisationsFactory'];
export function jointjsHacksRun(JointjsOptimisationsFactory) {

  JointjsOptimisationsFactory.init();

}


